import { render, staticRenderFns } from "./ReservationConversations.vue?vue&type=template&id=5b37ee3a&scoped=true"
import script from "./ReservationConversations.vue?vue&type=script&lang=js"
export * from "./ReservationConversations.vue?vue&type=script&lang=js"
import style0 from "./ReservationConversations.vue?vue&type=style&index=0&id=5b37ee3a&prod&lang=scss"
import style1 from "./ReservationConversations.vue?vue&type=style&index=1&id=5b37ee3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37ee3a",
  null
  
)

export default component.exports